// src/components/schedule/TimePickerModal.tsx
import React, { useState, useEffect } from 'react';

interface TimePickerModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (time: string) => void;
  initialTime?: string;
}

const TimePickerModal: React.FC<TimePickerModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  initialTime = '09:00'
}) => {
  const [hour, setHour] = useState<string>('09');
  const [minute, setMinute] = useState<string>('00');

  useEffect(() => {
    if (initialTime) {
      const [h, m] = initialTime.split(':');
      setHour(h);
      setMinute(m);
    }
  }, [initialTime, visible]);

  const handleConfirm = () => {
    onConfirm(`${hour}:${minute}`);
  };

  // Create arrays for hours and minutes
  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  const minutes = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  if (!visible) return null;

  return (
    <div className="time-picker-modal">
      <div className="time-picker-backdrop" onClick={onCancel}></div>
      <div className="time-picker-container">
        <div className="time-picker-header">
          <h2>Select Time</h2>
          <button className="time-picker-close" onClick={onCancel}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        
        <div className="time-picker-content">
          <div className="time-picker-selectors">
            <div className="time-picker-column">
              <label>Hour</label>
              <select 
                value={hour}
                onChange={(e) => setHour(e.target.value)}
                className="time-picker-select"
              >
                {hours.map((h) => (
                  <option key={h} value={h}>
                    {h}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="time-picker-divider">:</div>
            
            <div className="time-picker-column">
              <label>Minute</label>
              <select 
                value={minute}
                onChange={(e) => setMinute(e.target.value)}
                className="time-picker-select"
              >
                {minutes.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="time-picker-actions">
            <button 
              className="time-picker-cancel" 
              onClick={onCancel}
            >
              Cancel
            </button>
            <button 
              className="time-picker-confirm" 
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimePickerModal;